var map = {
	"./geboortekaart-op-maat-Esther-aquarel-watercolor-tekening-meisje-digitaal-drukwerk-doopsuiker-1.jpg": "2047",
	"./geboortekaart-op-maat-Esther-aquarel-watercolor-tekening-meisje-digitaal-drukwerk-doopsuiker-2.jpg": "d71d",
	"./geboortekaart-op-maat-Esther-aquarel-watercolor-tekening-meisje-digitaal-drukwerk-doopsuiker-thumbnail.png": "c3a5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7b71";